import { useHorizontalStepContainer, useHorizontalStepTrackContainer, useHorizontalStepTrack } from '../useHorizontalStep.js';
import { getMarkerHorizontalSpacing } from '../../../../helpers/Step.helpers.js';

var useDynamicHorizontalStep = function useDynamicHorizontalStep(props) {
  var state = props.state,
    size = props.size,
    markerContent = props.markerContent,
    stepAlignment = props.stepAlignment;
  return {
    stepContainerProps: useHorizontalStepContainer(stepAlignment),
    markerAndTrackContainerProps: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      my: getMarkerHorizontalSpacing(size),
      'aria-hidden': true
    },
    trackContainerProps: useHorizontalStepTrackContainer({
      size: size
    }),
    trackProps: useHorizontalStepTrack({
      size: size,
      state: state
    }),
    markerProps: {
      state: state,
      size: size,
      content: markerContent
    }
  };
};

export { useDynamicHorizontalStep };
//# sourceMappingURL=useDynamicHorizontalStep.js.map
